var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":"","color":"white"},on:{"click":_vm.logOut}},[_c('span',{staticClass:"mr-2"},[_vm._v("Logout")]),_c('v-icon',[_vm._v("mdi-logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }